import AccountSwitcherList from './AccountSwitcherList';

export default AccountSwitcherList;
